import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import Ratio from 'react-bootstrap/Ratio'
import LayoutSiaLearner from '../../../Shared/Layout/LayoutSiaLearner'
import { SIA_NAVY, SIA_GOLD_ACTIVE_BG } from '../../../constants/siaTheme'
import { getYouTubeThumbnail } from '../../../utils/youtube'

function DownloadIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 3v10.17l-3.88-3.88L6 11l6 6 6-6-1.12-1.12L13 13.17V3h-2zm-6 16v2h14v-2H5z" />
        </svg>
    )
}

function PlayIcon({ size = 18 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 5v14l11-7z" />
        </svg>
    )
}

const CulturaInstitucionalCatalog = ({ materials, canManage = false }) => {
    const [playing, setPlaying] = useState(null)

    return (
        <>
            {canManage && (
                <div className="d-flex justify-content-end mb-4">
                    <a href="/admin/sia/manage/cultura-institucional" className="btn btn-sm btn-light-primary">
                        Administrar material
                    </a>
                </div>
            )}

            <div
                className="rounded-3 mb-6 py-5 px-4 text-center text-white text-uppercase fw-bold fs-2 lh-sm shadow-sm"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.06em' }}
            >
                Cultura institucional
            </div>

            <p className="text-center text-gray-800 fw-semibold fs-5 mb-10 px-2">
                Conoce los valores, políticas y documentos de nuestra institución
            </p>

            <Row className="g-6 g-lg-8 mb-15 justify-content-center">
                {materials.length === 0 && (
                    <Col xs={12}>
                        <p className="text-center text-muted py-15">Pronto publicaremos el material de cultura institucional.</p>
                    </Col>
                )}
                {materials.map((m) => {
                    const isVideo = m.type === 'youtube' || m.type === 'mp4'
                    const canPlay = (m.type === 'youtube' && Boolean(m.youtube_id)) || (m.type === 'mp4' && Boolean(m.video_url))

                    return (
                        <Col key={m.id} xs={12} sm={6} md={6} lg={4} xl={3}>
                            <Card className="h-100 shadow-sm border border-gray-200 overflow-hidden rounded-3">
                                {canPlay && (
                                    <button
                                        type="button"
                                        className="border-0 p-0 position-relative d-block w-100"
                                        style={{ backgroundColor: SIA_NAVY }}
                                        onClick={() => setPlaying(m)}
                                        title="Reproducir video"
                                    >
                                        <Ratio aspectRatio="16x9">
                                            {m.type === 'youtube' ? (
                                                <img
                                                    src={getYouTubeThumbnail(m.youtube_id)}
                                                    alt={m.title}
                                                    loading="lazy"
                                                    style={{ objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <div />
                                            )}
                                        </Ratio>
                                        <span
                                            className="position-absolute top-50 start-50 translate-middle d-inline-flex align-items-center justify-content-center rounded-circle shadow"
                                            style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', width: '56px', height: '56px' }}
                                        >
                                            <PlayIcon size={28} />
                                        </span>
                                    </button>
                                )}
                                <Card.Body className="text-center py-8 px-5 flex-grow-1 d-flex flex-column justify-content-center">
                                    <Card.Title className="fs-5 fw-bold text-gray-900 lh-sm mb-0">{m.title}</Card.Title>
                                </Card.Body>
                                <div className="bg-light py-3 px-2 text-center border-top">
                                    {canPlay && (
                                        <button
                                            type="button"
                                            onClick={() => setPlaying(m)}
                                            className="d-inline-flex align-items-center justify-content-center rounded-1 border-0"
                                            style={{ backgroundColor: SIA_GOLD_ACTIVE_BG, width: '42px', height: '42px' }}
                                            title="Reproducir video"
                                        >
                                            <PlayIcon />
                                        </button>
                                    )}
                                    {isVideo && !canPlay && <span className="text-muted small">Sin video</span>}
                                    {!isVideo &&
                                        (m.has_download ? (
                                            <a
                                                href={route('sia.capacitacion.cultura-institucional.download', m.id)}
                                                className="d-inline-flex align-items-center justify-content-center rounded-1 text-decoration-none"
                                                style={{ backgroundColor: SIA_GOLD_ACTIVE_BG, width: '42px', height: '42px' }}
                                                title="Descargar"
                                            >
                                                <DownloadIcon />
                                            </a>
                                        ) : (
                                            <span className="text-muted small">Sin archivo</span>
                                        ))}
                                </div>
                            </Card>
                        </Col>
                    )
                })}
            </Row>

            <Modal show={playing !== null} onHide={() => setPlaying(null)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fs-5">{playing?.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0 bg-black">
                    {playing && (
                        <Ratio aspectRatio="16x9">
                            {playing.type === 'mp4' ? (
                                <video
                                    src={playing.video_url}
                                    title={playing.title}
                                    controls
                                    autoPlay
                                    playsInline
                                    preload="metadata"
                                    controlsList="nodownload"
                                    disablePictureInPicture
                                    onContextMenu={(e) => e.preventDefault()}
                                />
                            ) : (
                                <iframe
                                    src={`https://www.youtube-nocookie.com/embed/${playing.youtube_id}?autoplay=1&rel=0`}
                                    title={playing.title}
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            )}
                        </Ratio>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

CulturaInstitucionalCatalog.layout = (page) => <LayoutSiaLearner title="Cultura institucional | SIA">{page}</LayoutSiaLearner>

export default CulturaInstitucionalCatalog
